import { defineStore } from 'pinia';

export const usePageStatusStore = defineStore('pageStatus', {
    state: () => ({
        language: "es",
        landingShows: {
            scroll: 0,
            response: null
        },
        landingBooks: {
            scroll: 0,
            response: null
        }
    }),
    actions: {
        updateStatus(pos, response) {
            this.landingShows.scroll = pos;
            this.landingShows.response = response;
        },
        setLanguage(lang) {
            this.language = lang;
        }
    },
    persist: {
        paths: ['language']
    }
});